"use strict";
angular.module('manageSysManageEmailConfigModule', [])
    .controller('manageSysManageEmailConfigCtrl', ['$scope', 'trsHttpService', 'modalDialog', function($scope, trsHttpService, modalDialog) {
        initStatus();
        initData();
        /**
         * [initStatus description]
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.radiostatus = {
                singleSelect: {
                    sendWay: [{
                        desc: "使用PHP的mail函数发送",
                        value: "0",
                    }, {
                        desc: "通过SOCKET链接SMTP服务器发送（支持ESMTP验证，推荐方法）",
                        value: "1",
                    }, {
                        desc: "使用PHP的mail函数发送（仅Windows主机下有效，不支持ESMTP验证）",
                        value: "2",
                    }],
                    authentication: [{
                        desc: '是',
                        value: '0',
                    }, {
                        desc: '否',
                        value: '1',
                    }],
                    separator: [{
                        desc: '使用CRLF作为分隔符（常用，SMTP方式默认分隔符）',
                        value: '0',
                    }, {
                        desc: '使用LF作为分隔符（一些Unix主机使用mail函数时需用LF代替CRLF',
                        value: '1',
                    }, {
                        desc: '使用CR作为分隔符（通常为Mac主机，不常用）',
                        value: '2',
                    }],
                },
                showInput: false
            };
            $scope.list = "";
        }

        function initData() {
            requestData();
        }
        $scope.toggleRadio = function(item) {
            $scope.list.MEDIATYPES = item.value;
        };
        /**
         * [requestData description] 请求数据
         * @return {[type]} [description]
         */
        function requestData() {
            var params = {
                serviceid: 'mlf_websiteconfig',
                methodname: 'getSMTPServer'
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.status = data;
                $scope.list = data;
            });
        }
        /**
         * [modify description] 点击修改
         * @return {[type]} [description]
         */
        $scope.modify = function() {
            $scope.status = {
                SERVERNAME: $scope.status.SERVERNAME,
                SERVERPORT: $scope.status.SERVERPORT,
                SERVERUSER: $scope.status.SERVERUSER,
                PASSWORD: '',
            };
            $scope.original = angular.copy($scope.status);
            $scope.radiostatus.showInput = !$scope.radiostatus.showInput
        };
        /**
         * [cancel description] 取消修改
         * @return {[type]} [description]
         */
        $scope.cancel = function() {
            modalDialog.confirmModal("取消编辑", '是否放弃本次修改', function() {
                $scope.radiostatus.showInput = false;
                $scope.status = $scope.original;
            });
        };
        /**
         * [cancelModify description] 点击上面的路径取消修改
         * @return {[type]} [description]
         */
        $scope.cancelModify = function() {
            var isModify = angular.equals($scope.status, $scope.original); //比较是否修改
            if (isModify) {
                $scope.radiostatus.showInput = false;
            } else {
                modalDialog.confirmModal("取消编辑", '是否放弃本次修改', function() {
                    $scope.radiostatus.showInput = false;
                    $scope.status = $scope.original;
                });
            }
        };
        /**
         * [save description]保存邮件
         * @return {[type]} [description]
         */
        $scope.save = function() {
            var params = {
                serviceid: 'mlf_websiteconfig',
                methodname: 'saveSMTPServer',
                SERVERNAME: $scope.status.SERVERNAME,
                SERVERUSER: $scope.status.SERVERUSER,
                PASSWORD: $scope.status.PASSWORD,
                SERVERPORT: $scope.status.SERVERPORT,
                smtpFjr: $scope.status.smtpFjr,
                smtpYjqm: $scope.status.smtpYjqm
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                modalDialog.alertType('保存成功', "", "success", false, function() {
                    requestData();
                    $scope.emailConfigForm.$dirty = false;
                    $scope.radiostatus.showInput = false
                });
            });
        };
    }]);